import { InfoCircleOutlined } from "@ant-design/icons";
import { IndicadorWrapper } from "./styled";

function IndicadorSemDados() {
  return (
  <IndicadorWrapper>
    <InfoCircleOutlined />
    <h2>Nenhum dado encontrado. Altere os Filtros clique em "Consultar"</h2>
  </IndicadorWrapper>
  );
}

export default IndicadorSemDados;